import styled from 'styled-components';

export const CompanyHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

export const CompanyDivider = styled.div`
	width: 1px;
	height: 32px;
	background: #D9E1E8;
	flex-shrink: 0;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 16px;
`;

export const FieldRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;

	> * {
		flex: 1;
		min-width: 0;
	}
`;
